module.exports = __webpack_public_path__ + "img/announcement.f08f803e.webp";